import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://gf-qr-code.uc.r.appspot.com/v1/'

});

export default instance;
// baseURL: 'http://127.0.0.1/v1/'
// baseURL: 'http://127.0.0.1:8080/v1/'
// baseURL: 'https://gf-qr-code.uc.r.appspot.com/v1/'